import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/ui/Style";

import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {ThankYouPanelStyle} from "../thank-you/ThankYouPanel";
import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {authService} from "../../../../client/connection/Services";
import {DONATE_PAGE_URLS} from "../../PaywallConstants";
import {redirectToMerchantHomepage} from "../../../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";


class ThankYouMessageReceivedPanelStyle extends ThankYouPanelStyle {
    @styleRuleInherit
    text = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginBottom: 10,
    };

    @styleRule
    message = {
        padding: "12px 18px",
        color: this.themeProps.DONATE_PAGE_CARD_INPUT_COLOR,
    };

    @styleRuleInherit
    button = {
        marginBottom: 8,
    }
}

@registerStyle(ThankYouMessageReceivedPanelStyle)
export class ThankYouMessageReceivedPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;
        const merchantUser = iFrameUserDataService.getMerchantUser();

        if (!merchantUser) {
            return [];
        }

        return [
            <div className={styleSheet.title}>{Messages.thankYou}</div>,
            <div className={styleSheet.text}>{Messages.donatePageThankYouMessageReceived}</div>,
            <div className={styleSheet.message}>
                {merchantUser.formResponses?.donationMessage}
            </div>,
            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.button}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <PoweredByBlink />,
        ]
    }

    onMount() {
        super.onMount();
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
